import React, { Component } from 'react';
import {
  CercaAvançadaContainer,
  CercaAvançadaWrapper,
  CercaAvançadaHeader,
  CercaAvançadaTitleContainer,
  CercaAvançadaTitleWrapper,
  CercaAvançadaTitle,
  CercaAvançadaCloseBtn,
  CercaAvançadaCloseBtnIcon,
  SeparatorRow,
  CercaAvançadaBody,
  TextInputVerticalWrapper,
  TextInput,
  ButtonWrapper,
  NormalButton,
  TransparentButton,
  CercaBody,
  CercaBodyWrapper,
  TitolCercaBody,
  SpinnerContainer,
  CercaFooter,
  CercaFooterWrapper,
  TornarAlMapaButton,
  CercaAvançadaBodyWrapper,
  CercaAvançadaInstrucciones,
  InstruccionsTitle,
  InstruccionsDesc,
  Operador,
  InstruccionsHeader,
  InstruccionsWrapper,
  InstruccionsTextWrapper
} from './CercaAvançadaElement';
import { Oval } from 'react-loader-spinner';
import { toast } from 'react-toastify';

import TaulaResultatsCerca from '../TaulesCerca/TaulaResultatsCerca';
import CustomDropdown from './CustomDropdown';
import { cercaObj as Data } from '../Data';
import { cercaElements, cercaAdreça, cercaCadastre } from '../CercaUtils';
import { getTranslatedKey } from '../../Utils/TranslateUtils';
import { municipis } from './CercaData';
import { tipusVia } from './CercaData';
import { checkCoords, checkFormat, solrTextFormat } from '../../Utils/FormatUtils';
import { config } from '../../../config/Config';
import $j from 'jquery';
import { displayComponents } from '../../Utils/VisorsUtils';

let dropDownOpts = [
  getTranslatedKey('seleccionaCerca'),
  getTranslatedKey('dadesCataleg'),
  getTranslatedKey('toponim'),
  getTranslatedKey('adreça'),
  getTranslatedKey('puntKM'),
  getTranslatedKey('coordsUTM'),
  getTranslatedKey('coordsLatLon'),
  getTranslatedKey('parcelaCadastral')
];

export default class CercaAvançada extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: dropDownOpts[0],
      selectedLayer: getTranslatedKey('selectedLayerPH'),
      selectedTipusVia: getTranslatedKey('selectedTipusViaPH'),
      selectedPoblacio: getTranslatedKey('nomPoblacioPH'),
      page: 0,
      requestSolr: null,
      rowsPerPage: 8,
      arrayToponims: [],
      arrayElemsCapes: [],
      isLoading: false
    };
    this.arrayToponims = [];
    this.arrayElemsCapes = [];
    this.arrayLayerNames = [getTranslatedKey('selectedLayerPH')];
    this.arrayTipusVia = [getTranslatedKey('selectedTipusViaPH')];
    this.resizeTableRows = this.resizeTableRows.bind(this);
  }

  /**
   * @desc cuando se monta el componente, se definen las filas de la tabla
   */
  componentDidMount = async () => {
    window.addEventListener('resize', this.resizeTableRows);
    this.optionsAdjust();
    this.resizeTableRows();

    while (this.props.layerNames.length === 0) {
      await new Promise((resolve) => setTimeout(resolve, 200));
    }

    this.arrayLayerNames = this.props.layerNames
      .filter((layer) => !layer.isExternal())
      .map((layer) => layer.getTitle())
      .sort((a, b) => a.localeCompare(b));
    this.arrayLayerNames.unshift(getTranslatedKey('selectedLayerPH'));
    this.arrayTipusVia = tipusVia.map((tipus) => tipus.desc);
    this.arrayTipusVia.unshift(getTranslatedKey('selectedTipusViaPH'));
  };

  optionsAdjust = () => {
    if (!displayComponents.cercaFeatures) {
      dropDownOpts = dropDownOpts.filter((option) => option !== getTranslatedKey('dadesCataleg'));
    }
    if (!displayComponents.cercaPlaces) {
      dropDownOpts = dropDownOpts.filter(
        (option) =>
          option !== getTranslatedKey('toponim') &&
          option !== getTranslatedKey('adreça') &&
          option !== getTranslatedKey('puntKM') &&
          option !== getTranslatedKey('coordsLatLon') &&
          option !== getTranslatedKey('coordsUTM') &&
          option !== getTranslatedKey('parcelaCadastral')
      );
    }
  };

  /**
   * @desc Función que vacía los inputs cuando se cambia la opción seleccionada
   */
  componentDidUpdate = (prevProps, prevState) => {
    if (prevState.selectedOption !== this.state.selectedOption) {
      let elems = document.getElementsByClassName('textInputWrapper');
      Array.prototype.forEach.call(elems, function (el) {
        let allChilds = el.querySelectorAll('input[type="text"]');
        allChilds.forEach((element) => {
          element.value = '';
        });
      });
      this.arrayElemsCapes = [];
      this.clearToponims();
    }
  };

  /**
   * @desc mètode a executar quan el component es destrueix o es desmonta al DOM
   */
  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeTableRows);
  }

  /**
   * @desc función para cerrar el catalogo
   */
  onCloseBtnClick = () => {
    this.props.handleCercaAvançadaOpen(false);
    // this.resetCerca();
  };

  /**
   * @desc cambiar la opcion seleccionada
   */
  setSelectedOption = (option) => {
    this.setState({ selectedOption: option });
    // this.resetCerca();
  };

  /**
   *  @desc cambiar la layer seleccionada
   */
  setSelectedLayer = (option) => {
    this.setState({ selectedLayer: option });
  };

  /**
   *  @desc cambiar el tipo de via seleccionado
   */
  setSelectedTipusVia = (option) => {
    this.setState({ selectedTipusVia: option });
  };

  /**
   *  @desc cambiar la poblacion seleccionada
   */
  setSelectedPoblacio = (option) => {
    this.setState({ selectedPoblacio: option });
  };

  /**
   * @desc Función encargada de cambiar la pagina activa
   */
  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage });
  };

  /**
   *
   * @param {*} loadingState
   * @desc funcion para cambiar el estado de mostrar o no el spinner de loading
   */
  handleLoading = (loadingState) => {
    this.setState({ isLoading: loadingState });
  };

  /**
   * @desc resetear los inputs y los arrays de resultados
   */
  resetCerca = () => {
    this.setState({
      selectedLayer: getTranslatedKey('selectedLayerPH'),
      selectedTipusVia: getTranslatedKey('selectedTipusViaPH'),
      selectedPoblacio: getTranslatedKey('nomPoblacioPH'),
      reset: !this.state.reset
      // selectedOption: dropDownOpts[0]
    });
    let elems = document.getElementsByClassName('textInputWrapper');
    Array.prototype.forEach.call(elems, function (el) {
      let allChilds = el.querySelectorAll('input[type="text"]');
      allChilds.forEach((element) => {
        element.value = '';
      });
    });
    this.arrayElemsCapes = [];
    this.clearToponims();
    this.forceUpdate();
  };

  /**
   * @desc boton de cancelar
   */
  cancelButtonClick = () => {
    this.resetCerca();
  };

  /**
   * @desc Función encargada de calcular la cantidad de elementos que se verán en la tabla de resultados de la cerca según las medidas del navegador
   */
  resizeTableRows = () => {
    if (window.innerWidth <= 464) {
      let tableHeigth = window.innerHeight - 80 - 150 - 70;
      let rows = Math.trunc(tableHeigth / 45) - 4;
      this.setState({ rowsPerPage: rows });
    } else if (window.innerWidth <= 768) {
      let tableHeigth = 80 + 37 + 35 + 35 + 35 + 25 + 62 + 2 + 62;
      tableHeigth = window.innerHeight - tableHeigth;

      let rows = Math.round(Math.floor(tableHeigth - (20 + 5 + 52)) / (45 + 5));
      if (this.state.selectedOption === getTranslatedKey('toponim')) {
        rows = rows + 2;
      }
      this.setState({ rowsPerPage: rows });
    } else {
      let mapPart = window.innerHeight * 0.25;
      let tableHeigth = 40 + 40 + 2 + 25 + 35 + 35 + 35 + 25 + 62 + 2 + 62 + mapPart;
      tableHeigth = window.innerHeight - tableHeigth;
      let rows = Math.round(Math.floor(tableHeigth - (20 + 5 + 52)) / (45 + 5));
      if (this.state.selectedOption === getTranslatedKey('toponim')) {
        rows = rows + 2;
      }
      this.setState({ rowsPerPage: rows });
    }
    if (window.innerHeight < 400) {
      this.setState({ rowsPerPage: 3 });
    }
  };

  /**
   * @desc funcion para renderizar los inputs dependiendo de la opcion seleccionada
   */
  renderTextInput = () => {
    switch (this.state.selectedOption) {
      case getTranslatedKey('dadesCataleg'):
        return (
          <TextInputVerticalWrapper className="textInputWrapper">
            <CustomDropdown
              fontSizeEnabled={this.props.fontSizeEnabled}
              key="layerNames"
              id="layerNames"
              options={this.arrayLayerNames}
              margin={false}
              setSelected={this.setSelectedLayer}
              displayFilter={true}
              reset={this.state.reset}
            />
            <TextInput onKeyDown={(e) => this.onKeyDownSearch(e)} type="text" id="elementCapa" placeholder={getTranslatedKey('cercaPHCataleg')} />
          </TextInputVerticalWrapper>
        );
      case getTranslatedKey('toponim'):
        let topoMunicipis = municipis.map((x) => x);
        topoMunicipis[0] = getTranslatedKey('nomMun');
        return (
          <TextInputVerticalWrapper className="textInputWrapper">
            <TextInput onKeyDown={(e) => this.onKeyDownSearch(e)} type="text" id="toponim" placeholder={getTranslatedKey('cercaPHToponim')} />
          </TextInputVerticalWrapper>
        );
      case 'Parcel·la cadastral':
        return (
          <TextInputVerticalWrapper className="textInputWrapper">
            <TextInput onKeyDown={(e) => this.onKeyDownSearch(e)} type="text" id="cadastre" placeholder={getTranslatedKey('cadastrePH')} />
          </TextInputVerticalWrapper>
        );
      case getTranslatedKey('adreça'):
        return (
          <TextInputVerticalWrapper className="textInputWrapper">
            <CustomDropdown
              fontSizeEnabled={this.props.fontSizeEnabled}
              id="poblacio"
              key="poblacio"
              options={municipis}
              margin={false}
              setSelected={this.setSelectedPoblacio}
              displayFilter={true}
              reset={this.state.reset}
            />
            <CustomDropdown
              fontSizeEnabled={this.props.fontSizeEnabled}
              id="tipusVia"
              key="tipusVia"
              options={this.arrayTipusVia}
              margin={false}
              setSelected={this.setSelectedTipusVia}
              displayFilter={true}
              reset={this.state.reset}
            />
            <TextInput onKeyDown={(e) => this.onKeyDownSearch(e)} type="text" id="carrer" placeholder={getTranslatedKey('cercaPHAdress1')} />
            <TextInput onKeyDown={(e) => this.onKeyDownSearch(e)} type="text" id="portal" placeholder={getTranslatedKey('cercaPHAdress2')} />
          </TextInputVerticalWrapper>
        );
      case getTranslatedKey('puntKM'):
        return (
          <TextInputVerticalWrapper className="textInputWrapper">
            <TextInput onKeyDown={(e) => this.onKeyDownSearch(e)} type="text" id="codi" placeholder={getTranslatedKey('cercaPHpk1')} />
            <TextInput onKeyDown={(e) => this.onKeyDownSearch(e)} type="text" id="km" placeholder={getTranslatedKey('cercaPHpk2')} />
          </TextInputVerticalWrapper>
        );
      case getTranslatedKey('coordsUTM'):
        return (
          <TextInputVerticalWrapper className="textInputWrapper">
            <TextInput onKeyDown={(e) => this.onKeyDownSearch(e)} type="text" id="coordX" placeholder={getTranslatedKey('cercaCoordPH1')} />
            <TextInput onKeyDown={(e) => this.onKeyDownSearch(e)} type="text" id="coordY" placeholder={getTranslatedKey('cercaCoordPH2')} />
          </TextInputVerticalWrapper>
        );
      case getTranslatedKey('coordsLatLon'):
        return (
          <TextInputVerticalWrapper className="textInputWrapper">
            <TextInput onKeyDown={(e) => this.onKeyDownSearch(e)} type="text" id="lat" placeholder={getTranslatedKey('cercaLatLonPH1')} />
            <TextInput onKeyDown={(e) => this.onKeyDownSearch(e)} type="text" id="long" placeholder={getTranslatedKey('cercaLatLonPH2')} />
          </TextInputVerticalWrapper>
        );
      default:
        break;
    }
  };

  onKeyDownSearch = (e) => {
    if (e.key === 'Enter') {
      this.cercaAvançada(this.props.onClickElementCerca, this.props.cercaSolr);
    }
  };

  /**
   *
   * @param {*} onClickElementCerca
   * @desc funcion encargada de llamar a los servicios de busqueda en funcion del texto de los input
   */
  cercaAvançada = async (onClickElementCerca) => {
    let isCorrect;
    switch (this.state.selectedOption) {
      //cas cerca de dades del cataleg
      case getTranslatedKey('dadesCataleg'):
        //obtenim el text introduit al input i comprovem que te el format correcte
        let elementCapa = document.getElementById('elementCapa').value;
        isCorrect = checkFormat({
          key: '',
          value: elementCapa,
          isNumber: false,
          required: true
        });
        let selectedLayer = this.state.selectedLayer === getTranslatedKey('selectedLayerPH') ? undefined : this.state.selectedLayer;
        if (isCorrect) {
          this.setState({ isLoading: true }, () => {
            this.cercaSolr(selectedLayer, elementCapa);
          });
        }
        break;
      //cas toponim
      case getTranslatedKey('toponim'):
        //obtenim el text introduit al input i comprovem que te el format correcte
        let toponim = document.getElementById('toponim').value;
        isCorrect = checkFormat({
          key: '',
          value: toponim,
          isNumber: false,
          required: true
        });
        if (isCorrect) {
          await cercaElements(this.addToponim, this.clearToponims, onClickElementCerca, toponim, this.handleLoading, undefined, true);
          this.handleLoading(false);
        }
        break;
      //cas cadastre
      case 'Parcel·la cadastral':
        let cadastre = document.getElementById('cadastre').value;
        isCorrect = checkFormat({
          key: '',
          value: cadastre,
          isNumber: false,
          required: true
        });
        if (isCorrect) {
          if (cadastre.length < 14 || cadastre.length > 14) {
            toast.warn(getTranslatedKey('warnCharacters'));
          } else {
            await cercaCadastre(cadastre, this.goToCadastre);
            this.handleLoading(false);
          }
        }
        break;
      //cas adreça
      case getTranslatedKey('adreça'):
        //obtenim els texts introduits als inputs i comprovem que tenen el format correcte
        let carrer = document.getElementById('carrer').value;
        let portal = document.getElementById('portal').value;
        if (this.state.selectedTipusVia !== getTranslatedKey('selectedTipusViaPH'))
          var tipusAbrev = tipusVia.find((via) => via.desc === this.state.selectedTipusVia).type;
        let adreça = this.state.selectedPoblacio + ';' + tipusAbrev + ';' + carrer + ';' + portal;
        isCorrect =
          checkFormat({
            key: 'Nom de carrer',
            value: carrer,
            isNumber: false,
            required: true
          }) &&
          checkFormat({
            key: 'Número de porta',
            value: portal,
            isNumber: true,
            required: false
          });
        if (isCorrect) {
          if (this.state.selectedPoblacio === getTranslatedKey('nomPoblacioPH')) {
            toast.warn(getTranslatedKey('warnMun'));
          } else {
            await cercaAdreça(this.addToponim, this.clearToponims, onClickElementCerca, adreça, this.handleLoading);
            this.handleLoading(false);
          }
        }
        break;
      //cas pk
      case getTranslatedKey('puntKM'):
        //obtenim els texts introduits als inputs i comprovem que tenen el format correcte
        let codi = document.getElementById('codi').value;
        let km = document.getElementById('km').value;
        let pk = codi + ', ' + km;
        isCorrect =
          checkFormat({
            key: 'Codi de carretera',
            value: codi,
            isNumber: false,
            required: true
          }) &&
          checkFormat({
            key: 'Quilòmetre',
            value: km,
            isNumber: true,
            required: true
          });
        if (isCorrect) {
          await cercaElements(this.addToponim, this.clearToponims, onClickElementCerca, pk, this.handleLoading, this.onCloseBtnClick, true);
        }
        break;
      //cas coords utm
      case getTranslatedKey('coordsUTM'):
        //obtenim els texts introduits als inputs i comprovem que tenen el format correcte
        let coordX = document.getElementById('coordX').value;
        let coordY = document.getElementById('coordY').value;
        isCorrect =
          checkFormat({
            key: 'Coordenada X',
            value: coordX,
            isNumber: true,
            required: true
          }) &&
          checkFormat({
            key: 'Coordenada Y',
            value: coordY,
            isNumber: true,
            required: true
          });
        let coords = coordX + ', ' + coordY;
        if (isCorrect && checkCoords(false, coordX, coordY)) {
          await cercaElements(this.addToponim, this.clearToponims, onClickElementCerca, coords, this.handleLoading, undefined, true);
          this.onCloseBtnClick();
        }
        break;
      //cas coords lat lon
      case getTranslatedKey('coordsLatLon'):
        //obtenim els texts introduits als inputs i comprovem que tenen el format correcte
        let lat = document.getElementById('lat').value;
        let long = document.getElementById('long').value;
        isCorrect =
          checkFormat({
            key: 'Latitud',
            value: lat,
            isNumber: true,
            required: true
          }) &&
          checkFormat({
            key: 'Longitud',
            value: long,
            isNumber: true,
            required: true
          });
        let coord = lat + ', ' + long;
        if (isCorrect && checkCoords(true, lat, long)) {
          await cercaElements(this.addToponim, this.clearToponims, onClickElementCerca, coord, this.handleLoading, undefined, true);
          this.onCloseBtnClick();
        }
        break;

      default:
        break;
    }
    this.setState({});
  };
  /**
   * @desc Función encargada de gestionar el click en una resultado de una dirección
   */
  clickAdreça = (adreça) => {
    cercaAdreça(this.addToponim, this.clearToponims, this.props.onClickElementCerca, adreça, this.handleLoading);
  };

  /**
   * @desc Función encargada de añadir un nuevo toponimo al estado de la pàgina
   */
  addToponim = async (toponim) => {
    toponim.isToponim = true;
    this.setState({ arrayToponims: [...this.state.arrayToponims, toponim] });
    this.arrayToponims.push(toponim);
  };

  /**
   * @desc Función encargada de añadir un nuevo cadastro al estado de la pàgina
   */
  goToCadastre = (coords) => {
    if (coords === 'error') {
      toast.warn(getTranslatedKey('warmNoCadastre'));
    } else {
      this.props.onClickElementCerca(coords, false, true);

      this.props.handleCercaAvançadaOpen(false);
    }
  };

  /**
   *
   * @param {*} search
   * @desc funcion para hacer una busqueda en solr
   */
  cercaSolr = async (layer, search) => {
    search = solrTextFormat(search);

    while (this.props.layerNames.length === 0) {
      await new Promise((resolve) => setTimeout(resolve, 500));
    }
    let layerNames = layer
      ? [this.props.layerNames.find((l) => l.getTitle() === layer).getName()]
      : this.props.layerNames.filter((layer) => !layer.isExternal() && layer.getExtension().Searchable).map((layer) => layer.getName());
    if (layerNames.length === 0) return;
    let searchRequest = {
      q: search,
      continguts: layerNames,
      limit: 100,
      offset: 0,
      field: 'Cerca'
    };

    let $request = this.state.requestSolr;
    if ($request != null) {
      $request.abort();
      this.setState({ requestSolr: null });
    }

    //PRE
    // let url = config.url_solrPRE;

    //PRO
    let url = config.url_solrPRO;

    $request = $j.ajax({
      type: 'POST',
      url: url,
      data: JSON.stringify(searchRequest),
      contentType: 'application/json; charset="utf-8"',
      dataType: 'json',
      cache: false,
      success: (data) => {
        if (data.length === 0) {
          toast.warn(getTranslatedKey('warnNoResults'), { autoClose: 2500, pauseOnHover: true });
          this.arrayElemsCapes = [];
        } else {
          this.arrayElemsCapes = data;
          this.setState({ arrayToponims: data, arrayElemsCapes: data });
        }
      },
      error: function () {
        toast.error(getTranslatedKey('searchError'));
      },
      complete: function () {
        this.handleLoading(false);
      }.bind(this)
    });
    this.setState({ requestSolr: $request });
  };

  /**
   * @desc Función encargada de limpiar la lista de elementos de la cerca
   */
  clearToponims = () => {
    this.arrayToponims = [];
    this.setState({ arrayToponims: [] });
  };

  render() {
    return (
      <>
        <CercaAvançadaContainer id="CercaAvançadaContainer" cercaAvançadaOpen={this.props.cercaAvançada} mapHeight={this.props.mapHeight}>
          <CercaAvançadaWrapper id="CercaAvançadaWrapper">
            <CercaAvançadaHeader id="CercaAvançadaHeader">
              <CercaAvançadaTitleContainer>
                <CercaAvançadaTitleWrapper>
                  <CercaAvançadaTitle id="CercaAvançadaTitle" title={getTranslatedKey('cercaAvançada')} fontSizeEnabled={this.props.fontSizeEnabled}>
                    {getTranslatedKey('cercaAssistidaTitle')}
                  </CercaAvançadaTitle>
                </CercaAvançadaTitleWrapper>
              </CercaAvançadaTitleContainer>
              <CercaAvançadaCloseBtn
                id="CercaAvançadaCloseBtn"
                title={getTranslatedKey('tancar')}
                onClick={this.onCloseBtnClick}
                aria-label={getTranslatedKey('aria_tancarCataleg')}>
                <CercaAvançadaCloseBtnIcon
                  id="CercaAvançadaCloseBtnIcon"
                  src={Data.closeIcon}
                  alt={getTranslatedKey('aria_tancarCataleg')}
                  fontSizeEnabled={this.props.fontSizeEnabled}></CercaAvançadaCloseBtnIcon>
              </CercaAvançadaCloseBtn>
            </CercaAvançadaHeader>
            <SeparatorRow id="SeparatorRowHeaderCatalog" />
            <CercaAvançadaBody>
              <CercaAvançadaBodyWrapper>
                <CustomDropdown
                  fontSizeEnabled={this.props.fontSizeEnabled}
                  options={dropDownOpts}
                  setSelected={this.setSelectedOption}
                  margin={true}
                  displayFilter={false}
                  // reset={this.state.reset}
                />
                {this.renderTextInput()}
                {this.state.selectedOption ? (
                  <CercaBody id="CercaBody">
                    <ButtonWrapper>
                      <TransparentButton onClick={() => this.cancelButtonClick()}>{getTranslatedKey('cercaAssistidaCancelar')}</TransparentButton>
                      <NormalButton
                        onClick={() => this.cercaAvançada(this.props.onClickElementCerca, this.props.cercaSolr)}
                        className={`cerca-avançada-btn-${this.state.selectedOption}`}>
                        {getTranslatedKey('cercaAssistidaCercar')}
                      </NormalButton>
                    </ButtonWrapper>
                    {this.state.selectedOption !== getTranslatedKey('toponim') &&
                    this.state.selectedOption !== getTranslatedKey('dadesCataleg') &&
                    this.state.selectedOption !== getTranslatedKey('adreça') ? (
                      <></>
                    ) : !this.state.isLoading ? (
                      ((this.state.selectedOption === getTranslatedKey('toponim') || this.state.selectedOption === getTranslatedKey('adreça')) &&
                        this.arrayToponims.length > 0) ||
                      (this.state.selectedOption === getTranslatedKey('dadesCataleg') && this.arrayElemsCapes.length > 0) ? (
                        <CercaBodyWrapper id="CercaBodyWrapper">
                          <TitolCercaBody id="TitolCercaBody" fontSizeEnabled={this.props.fontSizeEnabled}>
                            {getTranslatedKey('cercaAssistidaResultats')} (
                            {this.state.selectedOption === getTranslatedKey('dadesCataleg') ? this.arrayElemsCapes.length : this.arrayToponims.length}
                            )
                          </TitolCercaBody>
                          <TaulaResultatsCerca
                            id="TaulaResultatsCerca"
                            clickAdreça={this.clickAdreça}
                            isCapes={this.state.selectedOption === getTranslatedKey('dadesCataleg') ? 'elements' : 'localitzacions'}
                            elementsList={this.state.selectedOption === getTranslatedKey('dadesCataleg') ? this.arrayElemsCapes : this.arrayToponims}
                            page={this.state.page}
                            rowsPerPage={this.state.rowsPerPage}
                            totalRows={
                              this.state.selectedOption === getTranslatedKey('dadesCataleg') ? this.arrayElemsCapes.length : this.arrayToponims.length
                            }
                            handleChangePage={(event, newPage) => this.handleChangePage(event, newPage)}
                            fontSizeEnabled={this.props.fontSizeEnabled}
                            sitepLayerInfoMap={this.props.sitepLayerInfoMap}
                            onClickElementCerca={(coords, isGeolocalitzacio, isETRS, isElement, id, name) =>
                              this.props.onClickElementCerca(coords, isGeolocalitzacio, isETRS, isElement, id, name)
                            }
                            sitepLayers={this.props.catalogData}
                          />
                        </CercaBodyWrapper>
                      ) : (
                        <></>
                      )
                    ) : (
                      <SpinnerContainer>
                        <Oval
                          height={window.innerHeight > 464 ? 80 : 40}
                          width={window.innerHeight > 464 ? 80 : 40}
                          color="#febf00"
                          wrapperStyle={{}}
                          wrapperClass=""
                          visible={true}
                          ariaLabel="oval-loading"
                          secondaryColor="#ccc"
                          strokeWidth={2}
                          strokeWidthSecondary={2}
                        />
                      </SpinnerContainer>
                    )}
                  </CercaBody>
                ) : (
                  <></>
                )}
              </CercaAvançadaBodyWrapper>
              {this.state.selectedOption === getTranslatedKey('dadesCataleg') && this.arrayElemsCapes.length === 0 && !this.state.isLoading && (
                <CercaAvançadaInstrucciones fontSizeEnabled={this.props.fontSizeEnabled}>
                  <InstruccionsHeader>{getTranslatedKey('solROperatorsTitle')}</InstruccionsHeader>
                  <InstruccionsWrapper>
                    <Operador>" "</Operador>
                    <InstruccionsTextWrapper>
                      <InstruccionsTitle>{getTranslatedKey('solRTitle1')}</InstruccionsTitle>
                      <InstruccionsDesc>{getTranslatedKey('solRDesc1')}</InstruccionsDesc>
                    </InstruccionsTextWrapper>
                  </InstruccionsWrapper>
                  <InstruccionsWrapper>
                    <Operador>?</Operador>
                    <InstruccionsTextWrapper>
                      <InstruccionsTitle>{getTranslatedKey('solRTitle2')}</InstruccionsTitle>
                      <InstruccionsDesc>{getTranslatedKey('solRDesc2')}</InstruccionsDesc>
                    </InstruccionsTextWrapper>
                  </InstruccionsWrapper>
                  <InstruccionsWrapper>
                    <Operador>*</Operador>
                    <InstruccionsTextWrapper>
                      <InstruccionsTitle>{getTranslatedKey('solRTitle3')}</InstruccionsTitle>
                      <InstruccionsDesc>{getTranslatedKey('solRDesc3')}</InstruccionsDesc>
                    </InstruccionsTextWrapper>
                  </InstruccionsWrapper>
                  <InstruccionsWrapper>
                    <Operador>!</Operador>
                    <InstruccionsTextWrapper>
                      <InstruccionsTitle>{getTranslatedKey('solRTitle4')}</InstruccionsTitle>
                      <InstruccionsDesc>{getTranslatedKey('solRDesc4')}</InstruccionsDesc>
                    </InstruccionsTextWrapper>
                  </InstruccionsWrapper>
                  <InstruccionsWrapper>
                    <Operador>+</Operador>
                    <InstruccionsTextWrapper>
                      <InstruccionsTitle>{getTranslatedKey('solRTitle5')}</InstruccionsTitle>
                      <InstruccionsDesc>{getTranslatedKey('solRDesc5')}</InstruccionsDesc>
                    </InstruccionsTextWrapper>
                  </InstruccionsWrapper>
                </CercaAvançadaInstrucciones>
              )}
            </CercaAvançadaBody>
            <CercaFooter id="CercaFooter">
              <SeparatorRow id="SeparatorRowCerca" />
              <CercaFooterWrapper id="CercaFooterWrapper">
                <TornarAlMapaButton
                  title={getTranslatedKey('descripcioBoto')}
                  onClick={() => this.onCloseBtnClick()}
                  fontSizeEnabled={this.props.fontSizeEnabled}>
                  {getTranslatedKey('descripcioBoto')}
                </TornarAlMapaButton>
              </CercaFooterWrapper>
            </CercaFooter>
          </CercaAvançadaWrapper>
        </CercaAvançadaContainer>
      </>
    );
  }
}
